import { createFileRoute } from "@tanstack/react-router";

import { CoachAthleteMetricsPage } from "src/pages/CoachAthleteMetricsPage";
import { createPrivateMetricsRepository } from "src/repositories/metrics/createPrivateMetricsRepository";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/_tabs/metrics/",
)({
  component: CoachAthleteMetricsPage,
  ssr: true,
  async loader({ context, params }) {
    await context.queryClient.query({
      ...createPrivateMetricsRepository().summaryOptions(params.athleteId),
      staleTime: "static",
    });
  },
});
